import {getData, LOGIN} from "../../storage";
import {isEmpty, vuepayAlert} from "../../utility";
import api from "../../../util/clipstore/broadcaster/library";
import assets from "../../assets";
import strings from "../../strings";
import _ from "lodash";

/**
 * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * API START * * * * * * * * * * * * * * * * * * * * * * * *
 */
const getMyLibrary = (props, request) => {
    getData(LOGIN)
        .then((data) => {
            if (!isEmpty(data)) {
                props.getMyLibrary(
                    data.token,
                    data.api_token,
                    request.width,
                    request.height,
                    request.searchValue,
                    request.sortBy,
                );
            }
        })
}

const getMyGallery = (props, request) => {
    getData(LOGIN)
        .then((data) => {
            if (!isEmpty(data)) {
                props.getMyGallery(
                    data.token,
                    data.api_token,
                    request.width,
                    request.height
                );
            }
        })
}

const duplicateVideosAPI = (props, idArray, pictureIdArray) => {
    getData(LOGIN)
        .then((data) => {
            if (!isEmpty(data)) {
                props.duplicateVideos(
                    data.token,
                    data.api_token,
                    {
                        "ids": idArray,
                        "picture_ids": pictureIdArray
                    },
                );
            }
        })
}

const deleteVideosAPI = (props, idArray, pictureIdArray = []) => {
    getData(LOGIN)
        .then((data) => {
            if (!isEmpty(data)) {
                props.deleteVideos(
                    data.token,
                    data.api_token,
                    {
                        "ids": idArray,
                        "picture_ids": pictureIdArray
                    },
                );
            }
        })
}

const getUploadVideoLinkAPI = (props, id) => {
    getData(LOGIN)
        .then((data) => {
            if (!isEmpty(data)) {
                props.uploadLink(
                    data.token,
                    data.api_token,
                    id
                );
            }
        })
}

const getPredefinedTagsAPI = (props) => {
    //dispatch an action to get get all predefined tags from the Webservice
    getData(LOGIN)
        .then((data) => {
            if (!isEmpty(data)) {
                props.getPreDefinedTags(data.token, data.api_token);
            }
        })
}

const addVideoToLibraryAPI = (props, formData) => {
    //dispatch an action to POST the add video request to the Webservice
    getData(LOGIN)
        .then((data) => {
            if (!isEmpty(data)) {
                props.addVideoToLibrary(data.token, data.api_token, formData);
            }
        })
}

const addPictureToLibraryAPI = (props, formData) => {
    //dispatch an action to POST the add video request to the Webservice
    getData(LOGIN)
        .then((data) => {
            if (!isEmpty(data)) {
                props.addPictureToLibrary(data.token, data.api_token, formData);
            }
        })
}

const editVideoToLibraryAPI = (props, videoId, formData) => {
    //dispatch an action to PUT the add video request to the Webservice
    getData(LOGIN)
        .then((data) => {
            if (!isEmpty(data)) {
                props.editVideoToLibrary(data.token, data.api_token, videoId, formData);
            }
        })
}

const editPictureToLibraryAPI = (props, videoId, formData) => {
    //dispatch an action to PUT the add video request to the Webservice
    getData(LOGIN)
        .then((data) => {
            if (!isEmpty(data)) {
                props.editPictureToLibrary(data.token, data.api_token, videoId, formData);
            }
        })
}

const publishVideosAPI = (props, idsArray) => {
    //dispatch an action to POST the add video request to the Webservice
    getData(LOGIN)
        .then((data) => {
            if (!isEmpty(data)) {
                props.publishVideos(data.token, data.api_token, idsArray);
            }
        })
}

const addEditPricingAPI = (props, formData) => {
    //dispatch an action to POST the add video request to the Webservice
    getData(LOGIN)
        .then((data) => {
            if (!isEmpty(data)) {
                props.addEditPricing(data.token, data.api_token, formData);
            }
        })
}

const addContentToGalleryAPI = (props, videoIDArray, galleryId, type) => {
    //dispatch an action to POST the add video request to the Webservice
    getData(LOGIN)
        .then((data) => {
            if (!isEmpty(data)) {
                if (type === "picture") {
                    props.addPictureToGallery(data.token, data.api_token, {
                        "clipstore_picture_ids": videoIDArray,
                        "clipstore_gallery_id": galleryId
                    });
                } else {
                    props.addVideoToGallery(data.token, data.api_token, {
                        "clipstore_video_ids": videoIDArray,
                        "clipstore_gallery_id": galleryId
                    });
                }
            }
        })
}

const addGalleryAPI = (props, formData) => {
    //dispatch an action to POST the add video request to the Webservice
    getData(LOGIN)
        .then((data) => {
            if (!isEmpty(data)) {
                props.addGallery(data.token, data.api_token, formData);
            }
        })
}

const editGalleryAPI = (props,id, formData) => {
    //dispatch an action to POST the add video request to the Webservice
    getData(LOGIN)
        .then((data) => {
            if (!isEmpty(data)) {
                props.editGallery(data.token, data.api_token,id, formData);
            }
        })
}

const deleteGalleryAPI = (props, id) => {
    //dispatch an action to POST the add video request to the Webservice

    const payload = {
        image: assets.clipstore.delete_icon,
        title: strings.clipstore.broadcaster.delete_gallery.title,
        description: strings.clipstore.broadcaster.delete_gallery.description
    };
    const isConfirmationModal = true;
    const actionArray = [{
        text: "CANCEL",
        click: () => {
            console.log("Clicked on CANCEL");
            props.hideCommonModal()
        }
    }, {
        text: "DELETE",
        click: () => {
            console.log("Clicked on OK")
            getData(LOGIN)
                .then((data) => {
                    if (!isEmpty(data)) {
                        props.deleteGallery(data.token, data.api_token, id);
                    }
                })
        }
    }];

    props.showCommonModal(payload, isConfirmationModal, actionArray);
}
/**
 * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * API END * * * * * * * * * * * * * * * * * * * * * * * *
 */

const onDelete = (props, id,pictureIdArray) => {
    let payload = {
        image: assets.clipstore.delete_icon,
        title: strings.clipstore.broadcaster.delete_videos.title,
        description: strings.clipstore.broadcaster.delete_videos.description
    };

    if(pictureIdArray.length > 0){
        payload = {
            image: assets.clipstore.delete_icon,
            title: strings.clipstore.broadcaster.delete_pictures.title,
            description: strings.clipstore.broadcaster.delete_pictures.description
        };
    }
    const isConfirmationModal = true;
    const actionArray = [{
        text: "CANCEL",
        click: () => {
            console.log("Clicked on CANCEL");
            props.hideCommonModal()
        }
    }, {
        text: "DELETE",
        click: () => {
            console.log("Clicked on OK")
            api.deleteVideosAPI(props, id,pictureIdArray);
        }
    }];

    props.showCommonModal(payload, isConfirmationModal, actionArray);
}
const onFinishUpload = (props, signResult, refreshList) => {
    props.showCommonModal({
        image: assets.clipstore.success_icon,
        title: strings.clipstore.broadcaster.upload_success.title,
        description: strings.clipstore.broadcaster.upload_success.description,
        action: {
            text: "OK",
            click: () => {
                refreshList();
            }
        }
    });
}

const onErrorUpload = (props,id) => {
    const payload = {
        image: assets.clipstore.delete_icon,
        title: strings.clipstore.broadcaster.upload_failed.title,
        description: strings.clipstore.broadcaster.upload_failed.description
    };
    const isConfirmationModal = true;
    const actionArray = [{
        text: "CANCEL",
        click: () => {
            console.log("Clicked on CANCEL");
            props.hideCommonModal()
        }
    }, {
        text: "RETRY",
        click: () => {
            console.log("Clicked on RETRY")
            props.hideCommonModal()
            api.getUploadVideoLinkAPI(props, id);
        }
    }];

    props.showCommonModal(payload, isConfirmationModal, actionArray);
}

const handleAPIResponse = (nextProps, key, resetFunc, successCallback, errorCallback,hideSuccessAlert = false, hideErrorAlert = false) => {

    if (nextProps[key] && nextProps[key].payload != null) {

        //reset the payload value as we have captured the event
        resetFunc();

        if (nextProps[key].payload.hasOwnProperty("success") && nextProps[key].payload.success.hasOwnProperty("message")) {
            //refresh the library
            !hideSuccessAlert && vuepayAlert("success", nextProps[key].payload.success.message)
            successCallback(nextProps[key].payload);
        } else if (nextProps[key].hasOwnProperty("isError") && nextProps[key].isError) {
            if (nextProps[key].payload.hasOwnProperty("message")) {
                if(nextProps[key].payload.hasOwnProperty("response") &&
                    nextProps[key].payload.response.hasOwnProperty("error") &&
                    nextProps[key].payload.response.error.hasOwnProperty("message")){
                    !hideErrorAlert && vuepayAlert("error", nextProps[key].payload.response.error.message)
                    errorCallback(nextProps[key].payload);
                }else{
                    !hideErrorAlert && vuepayAlert("error", nextProps[key].payload.message)
                    errorCallback(nextProps[key].payload);
                }
            }
        }
    }
}

const formatPriceForAPI = (value) => {
    if (value === undefined || value === null) {
        return 0;
    } else {
        return value * 100;
    }
}

const formatPrice = (value, per) => {
    return `£ ${parseFloat(value / 100).toFixed(2)}/${per}`
}

const getVideoOrPictureArray = (contentList,id) => {
    let videoIdArray = [], pictureIdArray = [];

    _.map(contentList, (content) => {
        if (Array.isArray(id)) {
            _.map(id, (value) => {
                if (content.id === value) {
                    if (content.type === "picture") {
                        pictureIdArray.push(value)
                    } else {
                        videoIdArray.push(value)
                    }
                }
            });
        } else {
            if (content.id === id) {
                if (content.type === "picture") {
                    pictureIdArray.push(id)
                } else {
                    videoIdArray.push(id)
                }
            }
        }
    });

    return {
        "videoIdArray":videoIdArray,
        "pictureIdArray":pictureIdArray
    }
}

const getMyLibraryAPI = (props, request) => {
    getData(LOGIN)
        .then((data) => {
            if (!isEmpty(data)) {
                props.getMyLibrary(
                    data.token,
                    data.api_token,
                    request.width,
                    request.height,
                    request.searchValue,
                    request.sortBy,
                    request.page,
                );
            }
        })
}

export default {
    getMyLibrary,
    getMyGallery,
    duplicateVideosAPI,
    deleteVideosAPI,
    getUploadVideoLinkAPI,
    getPredefinedTagsAPI,

    addVideoToLibraryAPI,
    addPictureToLibraryAPI,

    editVideoToLibraryAPI,
    editPictureToLibraryAPI,

    publishVideosAPI,
    addEditPricingAPI,
    addContentToGalleryAPI,

    addGalleryAPI,
    editGalleryAPI,
    deleteGalleryAPI,

    onDelete,
    onFinishUpload,
    onErrorUpload,
    handleAPIResponse,
    formatPriceForAPI,
    formatPrice,
    getMyLibraryAPI,

    getVideoOrPictureArray
}